import PropTypes from "prop-types";

import ComboboxControl from "./Combobox";

// Wrapper for the Combobox component used only in CONTROLS
// to avoid rendering label and error twice when called through the Field control system.
const ComboboxWrapper = ({ isRequired = false, isClearable, ...props }) => (
  <ComboboxControl
    {...props}
    // A Field combobox clears unless the field is required.
    isClearable={isClearable ?? !isRequired}
    label=""
    hideBuiltInFieldError={true}
  />
);

ComboboxWrapper.propTypes = {
  isRequired: PropTypes.bool,
  isClearable: PropTypes.bool,
};

export default ComboboxWrapper;
